module.exports = __webpack_public_path__ + "media/card-covers/rio-de-janeiro-fbaacb16.png";